import { interpolate, t } from '~/utils/localization';
import Attention, { AttentionVariant } from '../Attention/Attention';
import { settings } from '~/utils/settings';
import { handleClick } from '~/hooks/useDelegationClickForLinkHandler';
import { BUNDLE_TYPES } from '~/types/bundle';
import styles from './ParentalControlsInformer.scss';
import { PURCHASE_ERROR_CODES } from '@wg/wows-commerce/constants/purchaseErrorCodes';
import { getPurchaseErrorCodeText } from '@wg/wows-commerce';

interface IParentalControlsInformer {
    bundle?: IBundle;
    errorCode?: keyof typeof PURCHASE_ERROR_CODES;
}

const ParentalControlsInformer = ({ bundle, errorCode }: IParentalControlsInformer) => {
    let text = t('This purchase is prohibited by {open_tag}parental controls{close_tag}.');

    if (bundle && bundle.isRandom) {
        text = t('Purchase of bundles or containers with randomly dropped items is prohibited by {open_tag}parental controls{close_tag}.');
    } else if (bundle && bundle.type === BUNDLE_TYPES.mystery) {
        text = t('Participation in events with randomly dropped items is prohibited by {open_tag}parental controls{close_tag}.');
    } else if (errorCode) {
        const message = getPurchaseErrorCodeText(errorCode);
        if (message) {
            text = getPurchaseErrorCodeText(errorCode).replace('{link-open}', '{open_tag}').replace('{link-close}', '{close_tag}');
        }
    }

    return (
        <Attention
            label={interpolate(text, {
                open_tag: `<a class="external-link with-border orange-link" data-type="parental_controls" data-place="purchase_block" href="${settings.urls.parentalControlUrl}" target="_blank"><span>`,
                close_tag: `</span></a>`,
            })}
            className={styles.linkWrapper}
            isHTML={true}
            level={'warning'}
            onClick={handleClick}
            variant={AttentionVariant.dark}
        />
    );
};

export default ParentalControlsInformer;
